import * as React from "react";

interface Comment { id: Number, text: string };
interface CommentGameState { data: Array<Comment>, correctResult: Comment, previousResult: Comment, photoUrl: string, answer_state: string, score: number, numAnswered: number, loading: boolean };
interface CommentResponse { comments: Array<Comment>, correct_result: Comment, photo_url: string };

const STATES = {
  unanswered: 'UNANSWERED',
  correct: 'CORRECT',
  wrong: 'WRONG'
}

export default class CommentGame extends React.Component<{}, CommentGameState> {
  constructor(props: Readonly<{}>) {
    super(props);
    this.state = {
      data: [],
      correctResult: null,
      previousResult: null,
      photoUrl: null,
      answer_state: STATES.unanswered,
      score: 0,
      numAnswered: 0,
      loading: false
    };
    this.fetchData = this.fetchData.bind(this);
  }

  async requestData() {
    const response = await fetch(
      "/comments.json"
    );
    return await response.json() as Promise<CommentResponse>;
  };

  fetchData() {
    this.setState({ loading: true });
    this.requestData().then(res => {
      const { comments, correct_result, photo_url } = res;
      this.setState({
        data: comments,
        correctResult: correct_result,
        photoUrl: photo_url,
        loading: false
      });
    });
  }

  componentDidMount() {
    this.fetchData();
  }

  selectResult(id) {
    const { correctResult, score, numAnswered } = this.state;
    this.setState({ numAnswered: numAnswered + 1, previousResult: correctResult });
    if (id == correctResult.id) {
      this.setState({ score: score + 1, answer_state: STATES.correct });
    } else {
      this.setState({ answer_state: STATES.wrong });
    }
    this.fetchData();
  }

  renderSelection(comment) {
    return (
      <div key={`comment_${comment.id}`} className='flex flex-row gap-2 items-center w-full'>
        <button type="button" className='p-2 bg-emerald-600 rounded text-white' onClick={(e) => this.selectResult(comment.id)} id={`link_${comment.id}`}>SELECT</button>
        <figure className="border border-slate-200 p-2 rounded w-full">
          <figcaption className="font-medium">{comment.user}</figcaption>
          <blockquote className="text-slate-900">
            {comment.text}
          </blockquote>
        </figure>
      </div>
    )
  }

  renderAnswer() {
    const { answer_state, previousResult } = this.state;
    if (answer_state == STATES.unanswered) {
      return null;
    }
    switch (answer_state) {
      case STATES.unanswered:
        return null;
      case STATES.correct:
        return (
          <div className='flex flex-col gap-2 p-2 bg-emerald-200 rounded text-emerald-800'>
            <h4 className="text-xl">Correct</h4>
            <p>{previousResult.text}</p>
          </div>
        );
      case STATES.wrong:
        return (
          <div className='flex flex-col gap-2 p-2 bg-red-200 rounded text-red-800'>
            <h4 className="text-xl">WRONG</h4>
            <p>Correct Answer: {previousResult.text}</p>
          </div>
        );
    }
  }

  renderScore() {
    const { score, numAnswered } = this.state;

    if (numAnswered == 0) {
      return null;
    }

    const percent = 100.0 * score / numAnswered;

    return (
      <p>
        Score ({score}/{numAnswered}), {percent}%
      </p>
    );
  }

  render() {
    const { data, photoUrl, loading } = this.state;

    if (loading) {
      return (
        <h1 className="text-4xl">Loading...</h1>
      );
    }

    return (
      <div className="flex flex-col gap-2">
        {this.renderAnswer()}
        {this.renderScore()}
        <img src={photoUrl}></img>
        <div className='flex flex-col gap-2'>
          {data.map((comment) => (this.renderSelection(comment)))}
        </div>
      </div>
    );
  }
}
